<template>
  <div class="img-preview">
    <img :src="getPic()" :alt="img" :title="img" />
  </div>
</template>
<script>

// import Images from `../assets/media/${getPic()}.jpg`;

export default {
  name: 'Preview',
  props: ['img'],
  data() {
    return {
      href: '',
    };
  },
  methods: {
    getPic() {
      this.href = this.img
        .replace('ą', 'a')
        .replace('Ą', 'A')
        .replace('ć', 'c')
        .replace('Ć', 'C')
        .replace('ę', 'e')
        .replace('Ę', 'E')
        .replace('ł', 'l')
        .replace('Ł', 'L')
        .replace('ń', 'n')
        .replace('Ń', 'N')
        .replace('ó', 'o')
        .replace('Ó', 'O')
        .replace('ś', 's')
        .replace('Ś', 'S')
        .replace('ź', 'z')
        .replace('Ź', 'Z')
        .replace('ż', 'z')
        .replace('Ż', 'Z')
        .replace(' ', '-')
        .replace('/ ', '')
        .toLowerCase();
      return require(`../assets/media/${this.href}.jpg`);
    },
  },
};
</script>

<style scoped>
  img{
    max-width: 225px;
    height: auto;
    display: block;
    margin: 5px auto;
  }
</style>
